import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;

	p {
		font-family: ${tokens.font_family_primary};
		font-weight: 500;
		font-size: 14px;
		color: ${tokens.color_gray_dark};
	}
`;

export const Circle = styled.div`
	height: 8px;
	width: 8px;
	border-radius: 50%;
	background-color: ${({ color }) => color};
`;
